import { replenishmentApi } from "@/shared/core-replenishments";
import { trackEvent } from "@/utils/firebase/analytics";

export const downloadRepositionsReport = async (params: string) => {
  const report = await replenishmentApi.exportRepositionsExcel(params);
  const reportURL = URL.createObjectURL(report);
  const link = document.createElement("a");
  link.href = reportURL;
  link.download = "repositions.xlsx";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(reportURL);

  trackEvent("export", {
    type: "xlsx",
    module: "repositions",
  });
};
